import download from 'downloadjs';
import { useMutation } from '@tanstack/react-query';

import { downloadLessonResource } from '@/data/services/resourceServices';
import Resource from '@/models/Resource';
import { getFileExtensionFromUrl } from '@/utils/file';
import { getErrorMessage } from '@/utils/getErrorMessage';
import alert from '@/utils/shared/alert';

type UseResourceDownloadParams = {
  lessonId: number;
};

type DownloadableResource = Pick<Resource, 'id' | 'title' | 'resourceFile'>;

const toFilename = ({ title, resourceFile }: DownloadableResource) => {
  const extension = getFileExtensionFromUrl(resourceFile ?? '').toLowerCase();

  return extension ? `${title}.${extension}` : title;
};

export default function useResourceDownload({
  lessonId,
}: UseResourceDownloadParams) {
  const { mutate, isPending } = useMutation({
    mutationFn: async (resource: DownloadableResource) => {
      const blob = await downloadLessonResource(lessonId, resource.id);

      download(blob, toFilename(resource), blob.type);
    },
    onError: (error: unknown) => alert.error(getErrorMessage(error)),
  });

  return { downloadResource: mutate, isDownloading: isPending };
}
